import React from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';

import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import InscriptionsModal from './InscriptionsModal/InscriptionsModal';
import {
    BudgetProposalT,
    CellRendererParams,
} from 'routes/BudgetModule/config/types';

const StyAmountWithInscriptionsButtonCellRenderer = styled(Box, {
    name: 'StyAmountWithInscriptionsButtonCellRenderer',
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'right',
    color: theme.palette.primary.main,
    fontWeight: 600,
    justifyContent: 'right',
}));

type Props = CellRendererParams<unknown, number> & {
    onInscriptionsModalOpened?: (arg1: void) => void;
    onInscriptionsModalClosed?: (arg1: void) => void;
    baseFilters: QueryFilterT[];
    budgetProposal: BudgetProposalT;
};

export default function AmountWithInscriptionsButtonCellRenderer({
    onInscriptionsModalOpened = () => {},
    onInscriptionsModalClosed = () => {},
    baseFilters,
    colDef,
    node,
    api,
    budgetProposal,
    valueFormatted,
}: Props): React.ReactElement {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const toggleModal =
        (open: boolean) => (event: React.MouseEvent | React.KeyboardEvent) => {
            if (
                event.type === 'keydown' &&
                'key' in event &&
                (event.key === 'Tab' || event.key === 'Shift')
            ) {
                return;
            }

            setIsModalOpen(open);
        };

    const onModalClose = (event: React.MouseEvent | React.KeyboardEvent) => {
        toggleModal(false)(event);
        onInscriptionsModalClosed();
    };
    // should not happen, just for typescript
    if (!colDef) return <></>;
    return (
        <StyAmountWithInscriptionsButtonCellRenderer>
            {valueFormatted}

            <IconButton
                color="primary"
                onClick={toggleModal(true)}
                size="small"
            >
                <EditIcon fontSize="small" />
            </IconButton>

            {isModalOpen && (
                <InscriptionsModal
                    open={isModalOpen}
                    baseFilters={baseFilters}
                    onOpen={onInscriptionsModalOpened}
                    onClose={onModalClose}
                    colDef={colDef}
                    gridApi={api}
                    node={node}
                    budgetProposal={budgetProposal}
                />
            )}
        </StyAmountWithInscriptionsButtonCellRenderer>
    );
}
